import React, { PureComponent } from 'react';
import { AtcSectorOpening, ExtendedMonitoredTv, MonitoredMcdmMeasure, MonitoredMeasure } from '../../../../model/SOL49';
import TimePeriodUtils from '../../../../common/util/TimePeriodUtils';
import { Flex } from '../../../common/Flex';
import { CountType, FlightId, TimePeriod } from '../../../../model/CORE';
import { AtcSectors } from './AtcSectors';
import Utils from '../../../../common/util/Utils';

interface SectorOpeningProps {
    currentTime: Date;
    monitoredPeriod: TimePeriod;
    monitoredTvs: Array<ExtendedMonitoredTv>;
    monitoredMeasures: Array<MonitoredMeasure>;
    monitoredMcdmMeasures: Array<MonitoredMcdmMeasure>;
    sectorOpening: AtcSectorOpening;
    countType: CountType;
    tvsOccupancyPeriods?: { [key: string]: Map<FlightId, TimePeriod> };
    selectedPeriodByTv?: Map<string, Array<TimePeriod>>;
    onSelectedPeriodByTvChange?: (selectedPeriodByTv: Map<string, Array<TimePeriod>>) => void;
}

export class SectorOpening extends PureComponent<SectorOpeningProps> {
    render() {
        const displayedTimePeriod = TimePeriodUtils.intersection(
            this.props.monitoredPeriod,
            this.props.sectorOpening.timePeriod,
        );
        const size =
            (
                (TimePeriodUtils.getDurationInMs(displayedTimePeriod) * 100) /
                TimePeriodUtils.getDurationInMs(this.props.monitoredPeriod)
            ).toFixed(2) + '%';

        const atcSectorTvsMap = new Map<string, Array<ExtendedMonitoredTv>>();
        if (Utils.isNotEmpty(this.props.sectorOpening.trafficVolumes)) {
            // Specific TVs have been configured - use them
            this.props.sectorOpening.trafficVolumes.forEach(tvId => {
                const monitoredTv = this.props.monitoredTvs.find(
                    monitoredTv => monitoredTv.trafficCounts.tvId === tvId,
                );
                if (monitoredTv) {
                    atcSectorTvsMap.set(monitoredTv.refLocation.id, [monitoredTv]);
                }
            });
        } else {
            // Guess which TVs need to be displayed based on their ref loc
            const configAirspaceIds = this.props.sectorOpening.airspaces.map(atcSector => atcSector.id);
            configAirspaceIds.forEach(airspaceId => {
                const monitoredTvs = this.props.monitoredTvs.filter(
                    monitoredTv => monitoredTv.tvRefLocation.refId === airspaceId,
                );
                atcSectorTvsMap.set(airspaceId, monitoredTvs);
            });
        }

        return (
            <Flex className="sector-opening" direction="vertical" size={size}>
                <Flex grow={false} style={{ fontWeight: 'bold', alignSelf: 'center', marginBottom: '0.25em' }}>
                    {this.props.sectorOpening.configId}
                </Flex>
                <Flex direction="vertical">
                    {Array.from(atcSectorTvsMap.keys())
                        .sort()
                        .map(airspaceId => (
                            <AtcSectors
                                key={`atc-sectors-${airspaceId}`}
                                currentTime={this.props.currentTime}
                                monitoredTvs={atcSectorTvsMap.get(airspaceId)}
                                monitoredMeasures={this.props.monitoredMeasures}
                                monitoredMcdmMeasures={this.props.monitoredMcdmMeasures}
                                airspaceId={airspaceId}
                                openingPeriod={this.props.sectorOpening.timePeriod}
                                tvsOccupancyPeriods={this.props.tvsOccupancyPeriods}
                                selectedPeriodByTv={this.props.selectedPeriodByTv}
                                onSelectedPeriodByTvChange={this.props.onSelectedPeriodByTvChange}
                                countType={this.props.countType}
                            />
                        ))}
                </Flex>
            </Flex>
        );
    }
}
